module.exports = __webpack_public_path__ + "static/media/48356655_2308772752531236_8968967607650615296_o.593de896.jpg";